import { createApp, h, reactive, type App } from 'vue'
import OneButtonMessagePopup from '@/components/OneButtonMessagePopup.vue'
import router from '@/router'

export interface ErrorPopupOptions {
  message: string
  route?: string
  status?: string
}

interface PopupState {
  visible: boolean
  message: string
  route?: string
  status?: string
}

const popupState = reactive<PopupState>({
  visible: false,
  message: '',
  route: undefined,
  status: undefined
})

let hostApp: App | null = null
let mountNode: HTMLDivElement | null = null

function ensureHostMounted(): void {
  if (hostApp) return

  mountNode = document.createElement('div')
  mountNode.id = 'global-error-popup-host'
  document.body.appendChild(mountNode)

  hostApp = createApp({
    setup() {
      const onConfirm = (): void => {
        popupState.visible = false
        popupState.message = ''
        popupState.route = undefined
        popupState.status = undefined
      }

      return () =>
        h(OneButtonMessagePopup, {
          visible: popupState.visible,
          message: popupState.message,
          route: popupState.route,
          status: popupState.status,
          onConfirm
        })
    }
  })

  hostApp.use(router)
  hostApp.mount(mountNode)
}

export function showErrorPopup(options: ErrorPopupOptions): void {
  if (popupState.visible) return

  ensureHostMounted()
  popupState.message = options.message
  popupState.route = options.route
  popupState.status = options.status
  popupState.visible = true
}

export function isErrorPopupVisible(): boolean {
  return popupState.visible
}
